import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { AiFillHeart } from "react-icons/ai";

function Footer() {
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="15" className="footer-copywright">
        <h3>Made with <AiFillHeart style={{ color: "black" }} /> by Yaoyi Wang</h3>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
